module.exports = __webpack_public_path__ + "static/kidsability-logo-7607e46b65558dfbec1c44e8f0d6f01c.jpg";